/* AI_ASSISTANT_PROFILe */
export const GET_AI_ASSISTANT_PROFILE = "GET_AI_ASSISTANT_PROFILE"
export const GET_AI_ASSISTANT_PROFILE_SUCCESS = "GET_AI_ASSISTANT_PROFILE_SUCCESS"
export const GET_AI_ASSISTANT_PROFILE_FAIL = "GET_AI_ASSISTANT_PROFILE_FAIL"

export const UPDATE_AI_ASSISTANT_PROFILE = "UPDATE_AI_ASSISTANT_PROFILE"
export const UPDATE_AI_ASSISTANT_PROFILE_SUCCESS = "UPDATE_AI_ASSISTANT_PROFILE_SUCCESS"
export const UPDATE_AI_ASSISTANT_PROFILE_FAIL = "UPDATE_AI_ASSISTANT_PROFILE_FAIL"
